<template>
  <b-container fluid style="margin-top:90px;">
    <b-card v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card>

    <b-card v-if="!loading">
      <b-table striped outlined hover :items="students"  @row-clicked="rowClicked" :fields="fields">

      </b-table>
    </b-card>
  </b-container>
</template>
<script>
import { ajaxGet, ajaxPost } from "../../ajax";
import {apiUrl} from "@/main";

export default {
    props: ["assignmentId", "token"],
    data: function() {
        return {
            loading: false,
            students: [],
            fields: [
                { key:"ID", label: "ID", sortable: true,thClass: 'd-none', tdClass: 'd-none' },
                { key:"Username", label: "Username", sortable: true},
                { key: "Firstname", label: "First Name", sortable: true },
                { key: "Lastname", label: "Last Name", sortable: true },
                { key: "HasAnswered", label: "Has Started", sortable: true },
                { key: "Score", label: "Score", sortable: true }
            ]
        };
    },
    mounted: function() {
        this.loading = true;
        var assignmentsPanel = this;

        setTimeout(function() {
            ajaxGet(
                 apiUrl() + "/assignments/" + assignmentsPanel.assignmentId + "/results/thin",
                assignmentsPanel.dataSuccessLoad,
                assignmentsPanel.dataError,
                assignmentsPanel.token
            );
        }, 50);
    },
    methods: {
        dataSuccessLoad: function(res) {
            this.students = res;
            this.loading = false;
        },
        dataError: function(status = 0) {
            if (status == 401) {
                this.$emit("logout");
                this.$router.push("/");
            }
        },
        rowClicked(record, index) {
            this.$router.push({ path: "/assignments/results/" + this.assignmentId + "/student/" + record.ID});
        }
    }
}
</script>